import React from 'react';
import './style.scss';
import { useCorporateAccountOpen, } from './hooks';

export const CorporateAccountOpen = () => {
  const { accountOpenPageType, SwitchPage } = useCorporateAccountOpen();

  return (
    <>
      <div className="accountOpen">{SwitchPage(accountOpenPageType)}</div>
    </>
  );
};
